/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from '@/store/modules/user'

import {
    getCustomerNameListByFinanceBackMoneyMainPart,
    getFinanceOrderByCustomerIdOrMarketCooperationId,
    setFinanceBackMoney,
    getFinanceBackMoneyById,
    getFinanceBackMoneyInfoById,
    setFinanceBackMoneyById,
    getFinanceBackMoneyDetailByFinanceInvoiceId
} from '@/api/financial-center'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { getDraftById, setDraftById } from '@/api/draft'
import { delNullProperty } from "@/utils";
import * as math from "mathjs";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {makeUploadSignature} from "@/utils/uploadMd5";
import {File} from "@/views/customer/customer-transfrom/edit-customer-info/interface";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class NewBackMoneyStaudent extends Vue {
    tableRandom = Math.random()
    limit = 20
    studentDialog = false
    studentDialogInputValue = ''
    studentDialogTaleData = []
    studentDialogTotal = 0
    studentDialogFilterTotal: number = null
    studentDialogPage = 1
    studentDialogTableLoading = false
    studentConfirmList = {
        customerCreatedAt: '',
        customerDirectorUserName: '',
        customerGrade: '',
        customerId: NaN,
        customerName: '',
        customerPhone: '',
        customerSource: '',
        customerSourceName: '',
        customerSpecialized: '',
        customerType: '',
        customerWeChat: '',
    }
    studentDialogSelect = {
        customerCreatedAt: '',
        customerDirectorUserName: '',
        customerGrade: '',
        customerId: NaN,
        customerName: '',
        customerPhone: '',
        customerSource: '',
        customerSourceName: '',
        customerSpecialized: '',
        customerType: '',
        customerWeChat: '',
    }

    orderDialog = false
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogTotal = 0
    orderDialogPage = 1
    orderDialogTableLoading = false
    orderDialogSelectTable = []
    oldOrderDialogSelectTable = [] //旧数据
    oldRowOrderDialogSelectTable: any = [] //取消行选中数据
    orderDialogSelect: any = []
    tableData = []
    newTable = []
    formData = {
        backMoneyContent: '学生',
        studentName: '',
        // backMoneyAccount: '北京集思互联教育科技有限公司',
        backMoneyAccount: '',
        date: new Date(),
        directorUserId: UserModule.userId || '',
        deparment: '',
        deparmentId: NaN,
        remark: '',  //备注
        payAccount: '',  //付款账户
        backMoneyWay:'' ,// 回款方式
        directorUserName: '',
        payMethod: '',
    }
    fileList = []
    backMoneyAccountOptions = [
        '苏州',
        '北京集思互联教育科技有限公司',
        '广州',
        '上海恒艾教育科技有限公司',
        '北京昌意科技有限公司',
        '天津集思互动教育咨询有限公司',
        '青岛集思互动教育咨询有限公司',
        '蒸汽松鼠（北京）科技有限公司'
    ]

    disabledButton = false
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'

    backMoneyId: number = null
    orderId: number = null
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 草稿id
    backMoneyStatus = ''
    isUpdatedData = '0'
    isShow = ''
    orderList = []
    tableKey = Math.random()
    formRule = {
        studentName: [{ required: true, message: '请选择学生名称', trigger: 'change' }],
        payMethod: [{ required: true, message: '请选择付款方式', trigger: 'change' }],
        date: [{ required: true, message: '请选择回款日期', trigger: 'change' }],
    }
    setPriceDialogShow = false //设置金额
    setPrice = ''
    file = []
    fileData = null
    readyOption = true
    // financeBackMoney = {
    //     financeBackMoneyDetailList:[]
    // }
    detailOrderArr: any = []
    previewVisible = false
    previewPath = ''
    previewName = ''
    timer = null
    timernew = null
    loading = false
    // isReadonly = false
    reasonDialogVisible = false
    needBackMoneyReason = ''
    isFrom = ''
    backMoneyWayOptions = [
        {label: '全额回款', value: '0'},
        {label: '扣佣金后回款', value: '1'},
        {label: '分期回款', value: '2'},
    ]
    setBackMoneyWay = '' // 一键设置回款方式
    setBackMoneyWayDialogShow = false
    pageloading = false
    // 定义全局上传参数对象（用于绑定 :data）
    uploadData = {
        bucket: 'crm',
        signature: '' // 初始值为空，后续实时更新
    }

    get userName() {
        return UserModule.userName
    }

    get department() {
        return UserModule.department
    }

    get directorUserId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.price))
        return num
    }
    // 回款详情总条数
    get detail_all_num() {
        return this.tableData.length
    }

    get shouldBackAmount() {
        // let allOrderAmount = 0
        // let alreadyAmount = 0
        let num = 0
        this.tableData.forEach(item => {
                // allOrderAmount += Number(item.price)
                // alreadyAmount += Number(item.needBackMoney)
            num = math.number(math.add(math.bignumber(num),math.bignumber( Number(item.needBackMoney))))
            }
        )
        return num
    }

    beforeUpload (file) {
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }

    uploadSuccess(response, file, fileList) {
        // console.log('uploadSuccess 触发:', {
        //     文件名: file.name,
        //     时间: Date.now(),
        //     响应: response,
        //     文件状态: file.status,
        //     文件列表状态: fileList.map(f => `${f.name}:${f.status}`)
        // });
        if (fileList.every(item => item.status == 'success')) {
            this.fileList = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.$message.success('上传成功');
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }

    handleSetPrice(val){
        val = this.handleOninput(val,'2')
        this.setPrice = this.handleOninput(val,'2')
    }
    handleOninput(num,limit){
        let str = num
        const len1 = str.substr(0, 1)
        const len2 = str.substr(1, 1)
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
            str = str.substr(1, 1)
        }
        //第一位不能是.
        if (len1 == ".") {
            str = ""
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
            const str_ = str.substr(str.indexOf(".") + 1)
            if (str_.indexOf(".") != -1) {
                str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
            }
        }
        //正则替换
        str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
        if (limit / 1 === 1) {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/,'$1') // 小数点后只能输 1 位
        } else {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1') // 小数点后只能输 2 位
        }
        return str
    }

    get surplusBackMoney() {
        let num = 0
        // let lastMoney = 0
        // this.financeBackMoney.financeBackMoneyDetailList.forEach(item => {
        //     lastMoney += Number(item.thisTimePrice)
        // })
        // num = num - lastMoney
        this.tableData.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.needBackMoney))))
        })
        return math.number(math.subtract(math.bignumber(num),math.bignumber(this.thisBackMoney)))
    }
    // 待回款金额
    get needBackMoney() {
        let num = 0
        // let lastMoney = 0
        // this.financeBackMoney.financeBackMoneyDetailList.forEach(item => {
        //     lastMoney += Number(item.thisTimePrice)
        // })
        // num = num - lastMoney
        this.tableData.forEach(item => {
            if (!item.newNeedBackMoney) {
                item.newNeedBackMoney = 0
            }
            if (!item.needBackMoney) {
                item.needBackMoney = 0
            }
            num = math.number(math.add(math.bignumber(num),math.bignumber(Number(item.newNeedBackMoney))))
        })
        return num
    }

    get thisBackMoney() {
        let num = 0
        this.tableData.forEach(
            item => num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.thisBackMoney))))
        )
        return num
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    created() {
        if(this.$route.query.orderId) {
            this.orderId = Number(this.$route.query.orderId)
            this.isFrom = this.$route.query.isFrom as any
            this.getFinanceBackMoneyInfoById()
        }

        if(this.$route.query.backMoneyId) {
            this.backMoneyId = Number(this.$route.query.backMoneyId)
            this.getFinanceBackMoneyById()
        }

        if(this.$route.query.draftId){
            this.draftId = Number(this.$route.query.draftId)
            this.getDraftById()
        }

        if (this.$route.query.makeInvoiceId) {
            //     从开票过来的回款
            this.getFinanceBackMoneyByMakeInvoiceId()
        }

        if(this.$route.query.status) this.backMoneyStatus = this.$route.query.status as string
        if(this.$route.query.isUpdatedData) this.isUpdatedData = this.$route.query.isUpdatedData as string
        if(this.$route.query.isShow) this.isShow = this.$route.query.isShow as string
    }

    menuBtn = menuBtn

    async getFinanceBackMoneyByMakeInvoiceId() {
        await getFinanceBackMoneyDetailByFinanceInvoiceId({financeInvoiceId: String(this.$route.query.makeInvoiceId)}).then((res: any) => {
            const data: any = res.financeBackMoneyDetail
            this.formData.studentName = data.customerName
            this.studentDialogSelect.customerId = data.customerId
            this.studentDialogSelect.customerSource = data.customerSource
            this.studentDialogSelect.customerSourceName = data.customerSourceName
            this.studentDialogSelect.customerType = data.customerType
            this.formData.backMoneyAccount = data.financeOrderList[0].companyName
            this.tableData = data.financeOrderList.map(item => {
                    return ({
                        ...item,
                        thisBackMoney: item.thisTimePrice,
                        thisBackMoneyWay: String(item.types),
                        oldThisBackMoney: 0,
                        newNeedBackMoney: math.number(math.subtract(math.bignumber(Number(item.needBackMoney)),math.bignumber(Number(item.thisTimePrice)))),
                    })
                }
            )
        })
    }

    changeWay(row, val) {
        if (val === '0') {
            row.thisBackMoney = row.price // 如果回款方式为全额回款，则本次回款金额默认为订单金额
        }
        this.tableData.forEach(item => {
            if(item.id === row.id) {
                item.newNeedBackMoney = math.number(math.subtract(math.bignumber(Number(item.needBackMoney)),math.bignumber(Number(row.thisBackMoney))))
            }
        })
    }

    async getFinanceBackMoneyById() {
        const data: any = await getFinanceBackMoneyById({ id: this.backMoneyId, isUpdatedData: this.isUpdatedData })
        const { financeBackMoney } = data
        this.editUserName = financeBackMoney.createdUserRealName
        this.editCreatedAt = new Date(financeBackMoney.createdAt)
        this.formData.backMoneyAccount = financeBackMoney.account
        this.formData.date = new Date(financeBackMoney.backMoneyAt)
        this.formData.directorUserId = financeBackMoney.directorUserId
        this.formData.directorUserName = financeBackMoney.directorUserRealName
        this.formData.studentName = financeBackMoney.customerOrCooperationName
        this.formData.deparment = financeBackMoney.directorDepartmentlName
        this.formData.deparmentId = financeBackMoney.directorDepartmentId
        this.formData.remark = financeBackMoney.remark
        this.formData.payAccount = financeBackMoney.payAccount
        this.formData.payMethod = financeBackMoney.payMethod == '第三方' ? '0' : financeBackMoney.payMethod == '银行' ? '1' : ''

        this.studentDialogSelect.customerName = financeBackMoney.customerOrCooperationName
        this.studentDialogSelect.customerId = financeBackMoney.customerId
        this.studentDialogSelect.customerSource = financeBackMoney.customerSource
        this.studentDialogSelect.customerSourceName = financeBackMoney.customerSourceName
        this.studentDialogSelect.customerType = financeBackMoney.customerType

        this.tableData = financeBackMoney.financeBackMoneyDetailList.map(item => {
            return {
                customerName: item.customerName,
                code: item.code,
                souCourseName: item.souCourseName,
                souCourseSchoolBegin: item.souCourseSchoolBegin,
                price: item.price,
                backMoney: item.backMoney,
                needBackMoney: this.isShow === '1' ? Number(item.needBackMoney) + Number(item.thisTimePrice):Number(item.needBackMoney),
                // newNeedBackMoney: item.needBackMoney,
                newNeedBackMoney: this.isShow == '1' ? item.needBackMoney : math.number(math.subtract(math.bignumber(item.needBackMoney), math.bignumber(item.thisTimePrice))),
                thisBackMoney: item.thisTimePrice,
                oldThisBackMoney: this.isShow === '1' ? item.thisTimePrice : 0, // 如果当前回款审批通过，在验证本次回款金额是否正确的时候就需要将本次回款的金额一起验证
                id: item.financeOrderId,
                companyName: item.companyName,
                thisBackMoneyWay: item.types == '全额回款' ? '0' : item.types == '扣佣金后回款' ? '1' : item.types == '分期回款' ? '2' : '', // 回款方式
            }
        })
        this.newTable = this.tableData

        this.fileList = financeBackMoney.financeBackMoneyProofList
    }
    defaultChecked(){
        this.$nextTick(() => {
            const order = (this.$refs.orderDialogTable as HTMLFormElement)
            order.clearSelection();
            this.tableData.forEach(row => {
                order.toggleRowSelection(row, true)
            })
        })
    }
    async getFinanceBackMoneyInfoById() {
        let obj
        if (this.isFrom) {
            obj = {mainPart: '0', id: this.orderId, isFrom: this.isFrom} // 如果是从报名学员列表过来的数据
        } else {
            obj = {mainPart: '0', id: this.orderId}
        }
        this.pageloading = true
        await getFinanceBackMoneyInfoById(obj).then((data: any) => {
            const {financeBackMoneyInfo} = data
            this.formData.studentName = financeBackMoneyInfo.customerName
            this.studentDialogSelect.customerName = financeBackMoneyInfo.customerName
            this.studentDialogSelect.customerSource = financeBackMoneyInfo.customerSource
            this.studentDialogSelect.customerSourceName = financeBackMoneyInfo.customerSourceName
            this.studentDialogSelect.customerType = financeBackMoneyInfo.customerType
            this.studentDialogSelect.customerId = financeBackMoneyInfo.customerId

            this.tableData.push({
                customerName: financeBackMoneyInfo.customerName,
                code: financeBackMoneyInfo.code,
                souCourseName: financeBackMoneyInfo.souCourseName,
                souCourseSchoolBegin: financeBackMoneyInfo.souCourseSchoolBegin,
                price: financeBackMoneyInfo.price,
                backMoney: financeBackMoneyInfo.backMoney,
                needBackMoney: financeBackMoneyInfo.needBackMoney,
                newNeedBackMoney: financeBackMoneyInfo.needBackMoney,
                thisBackMoney: 0,
                oldThisBackMoney: 0,
                id: this.orderId,
                thisBackMoneyWay: '', // 回款方式
            })
            this.formData.backMoneyAccount = financeBackMoneyInfo.companyName
            this.formData.payMethod = financeBackMoneyInfo.payMethod == '第三方' ? '0' : financeBackMoneyInfo.payMethod == '银行' ? '1' : ''

            this.pageloading = false
        }).catch(err => {
            this.pageloading = false
        })
    }

    // async directorUserIdChange(val) {
    //     const selectedItem = this.userList.find(item => item.id === val);
    //     this.formData.deparment = selectedItem.departmentName
    // }

    async getCustomerNameListByFinanceBackMoneyMainPart() {
        this.studentDialogTableLoading = true

        const obj = {
            mainPart: '0',
            page: this.studentDialogPage,
            customerNameOrMarketCooperationName:this.studentDialogInputValue,
            limit: this.limit
        }
        const data: any = await getCustomerNameListByFinanceBackMoneyMainPart(delNullProperty(obj))
        this.studentDialogTaleData = data.customerOrMarketCooperationList
        this.studentDialogTotal = data.allNum
        this.studentDialogTableLoading = false
        // this.isReadonly = false
        this.tableRandom = Math.random()
    }

    async getFinanceOrderByCustomerIdOrMarketCooperationId() {
        this.loading = true

        // 发请求拿到数据并暂存全部数据
        const obj = {
            mainPart: '0',
            customerId: this.studentDialogSelect.customerId,
            customerType: this.studentDialogSelect.customerType,
            page: this.orderDialogPage,
            limit: this.limit,
            customerName: this.orderDialogInputValue
        }
        const data: any = await getFinanceOrderByCustomerIdOrMarketCooperationId(delNullProperty(obj))
        this.orderDialogTaleData = data.financeOrderList
        this.orderDialogTotal = data.allNum
        this.tableRandom = Math.random()
        this.loading = false
        // this.isReadonly = false
    }

    getList() {
        //  es6过滤得到满足搜索条件的展示数据list
        const list = this.orderList.filter((item, index) =>
            item.customerName.includes(this.orderDialogInputValue)
        )
        //过滤分页
        this.orderDialogTaleData = list.filter((item, index) =>
            index < this.orderDialogPage * this.limit && index >= this.limit * (this.orderDialogPage - 1)
        );
        //分页的总数据
        this.orderDialogTotal = list.length
        this.setCheckedRows() //回显已勾选的数据
    }
    // 4、回显已勾选的数据
    setCheckedRows(){
        const a = (this.$refs.orderDialogTable as HTMLFormElement)
        this.orderDialogSelect = this.tableData.map(item => item.id);
        const selectItem = []
        this.$nextTick(() => {
            const { orderDialogSelect, orderList, tableData } = this
            tableData.forEach(key => {
                orderList.forEach(row => {
                    if (row.id == key.id) {
                        setTimeout(() => {
                            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row, true)
                        }, 300);
                    }
                })
            })
        })
    }
    // async getFinanceOrderByCustomerIdOrMarketCooperationId() {
    //     this.orderDialogTableLoading = true
    //     const obj = {
    //         mainPart: '0',
    //         page: this.orderDialogPage,
    //         customerId: this.studentDialogSelect.customerId,
    //         customerType: this.studentDialogSelect.customerType,
    //         limit: 2
    //     }
    //     const data: any = await getFinanceOrderByCustomerIdOrMarketCooperationId(obj)
    //     this.orderDialogTaleData = data.financeOrderList.map(item => ({ ...item, selectDisabled: true, newNeedBackMoney: item.needBackMoney }))
    //     this.orderDialogTotal = data.allNum
    //     this.orderDialogTableLoading = false
    //     this.$nextTick(() => {
    //         const dom = this.$refs.orderDialogTable as HTMLFormElement
    //         if(this.tableData.length > 0) {
    //             dom.clearSelection()
    //             const orderIds = this.tableData.map(item => item.id)
    //             const newArr = this.orderDialogTaleData.filter(item => orderIds.includes(item.id))
    //             newArr.forEach(item => {
    //                 dom.toggleRowSelection(item, true)
    //                 // item.selectDisabled = false * 2022.01.04 放弃禁用，改为回显
    //             })
    //         } else {
    //             dom.clearSelection()
    //         }
    //     })
    // }

    async getDraftById() {
        this.pageloading = true
        const data: any = await getDraftById(this.draftId).then((data: any) => {
            const {result} = data

            this.editUserName = result.createdUserRealName
            this.editCreatedAt = new Date(result.createdAt)

            this.formData.backMoneyAccount = result.account
            this.formData.date = new Date(result.backMoneyAt)
            this.formData.directorUserId = result.directorUserId
            this.formData.directorUserName = result.directorUserRealName
            this.formData.studentName = result.customerOrCooperationName
            this.formData.deparment = result.directorDepartmentlName
            this.formData.deparmentId = result.directorDepartmentId
            this.formData.remark = result.remark
            this.formData.payMethod = result.payMethod == '第三方' ? '0' : result.payMethod == '银行' ? '1' : ''

            this.studentDialogSelect.customerName = result.customerOrCooperationName
            this.studentDialogSelect.customerId = result.customerId
            this.studentDialogSelect.customerSource = result.customerSource
            this.studentDialogSelect.customerSourceName = result.customerSourceName
            this.studentDialogSelect.customerType = result.customerType

            this.tableData = result.financeBackMoneyDetailList.map(item => {
                return {
                    customerName: item.customerName,
                    code: item.code,
                    souCourseName: item.souCourseName,
                    souCourseSchoolBegin: item.souCourseSchoolBegin,
                    price: item.price,
                    backMoney: item.backMoney,
                    needBackMoney: Number(item.needBackMoney),
                    // newNeedBackMoney: item.needBackMoney,
                    newNeedBackMoney: math.number(math.subtract(math.bignumber(Number(item.needBackMoney)), math.bignumber(Number(item.thisTimePrice)))),
                    thisBackMoney: item.thisTimePrice,
                    oldThisBackMoney: 0,
                    id: item.financeOrderId,
                    thisBackMoneyWay: item.types == '全额回款' ? '0' : item.types == '扣佣金后回款' ? '1' : item.types == '分期回款' ? '2' : '', // 回款方式
                }
            })

            this.fileList = result.financeBackMoneyProofList
            this.pageloading = false
        }).catch(err => {
            this.pageloading = false
        })
    }

    async clickSubmintButton() {
        // if(!this.formData.studentName) { this.$message.error('请选择学生'); return }
        // if(!this.formData.backMoneyAccount) { this.$message.error('请选择收款账户'); return }
        let flag = true;
        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
            }
        })

        if(this.tableData.length === 0) { await this.$message.error('请添加订单'); return }

        if(this.fileList.length === 0) { await this.$message.error('请上传回款凭证'); return }

        if (!this.formData.backMoneyAccount) {
            await this.$message.error('收款账户不可为空');
            return
        }

        if (!this.formData.payMethod) {
            await this.$message.error('请选择付款方式');
            return;
        }
        const obj = {
            mainPart: '0',
            customerId: this.studentDialogSelect.customerId,
            customerType: this.studentDialogSelect.customerType,
            account: this.formData.backMoneyAccount,
            backMoneyAt: formatDate('yyyy-MM-dd', new Date(this.formData.date)),
            financeBackMoneyDetailList: [],
            financeBackMoneyProofList: this.fileList,
            directorUserId: this.formData.directorUserId,
            isDraft: this.isDraft,
            remark:this.formData.remark,
            payMethod: this.formData.payMethod,
            content: (this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney))) && this.isDraft !== '1') ? this.needBackMoneyReason : '',
            isFrom: this.isFrom ? '1' : '' // 如果是从报名学员列表过来的
        }


        obj.financeBackMoneyDetailList = this.tableData.map(item => {
            return ({
                financeOrderId: item.id,
                thisTimePrice: String(item.thisBackMoney),
                types: String(item.thisBackMoneyWay)
            })
        });

        const isAllZero = obj.financeBackMoneyDetailList.every(item => (item.thisTimePrice !== 0 && item.thisTimePrice !== ''));
        if (!isAllZero) {
            this.$message.error('有未填写本次回款金额的订单，请去填写')
            return;
        }
        /*判断this.tableData的每一项的thisBackMoneyWay都不为空*/
        if (!(obj.financeBackMoneyDetailList.every(item => (item.types !== '' && item.types !== 'undefined')))) {
            this.$message.error('有未填写本次回款方式的订单，请去填写')
            return
        }

        if (this.isDraft !== '1' && !this.needBackMoneyReason) {    // 正常新建 且不是存草稿
            /*判断每一个订单的本次回款金额是否等于待回款金额*/
            if (this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney)))) {
                this.reasonDialogVisible = true
                flag = false
            }
        }

        if (flag) {
            this.disabledButton = true
        } else {
            return
        }
        this.pageloading = true
        setFinanceBackMoney(delNullProperty(obj)).then(() => {
            this.$message.success(`${this.isDraft === '0' ? '新建成功' : '已保存到草稿箱'}`)
            this.pageloading = false
            setTimeout(() => {
                this.closePage()
            }, 1500)
            this.saveDraftDialogShow = false
        }).catch((err: Error) => {
            if (err) {
                this.disabledButton = false
                this.needBackMoneyReason = ''
            }
            if (err.message === '审批流报错') {
                this.errorDialogShow = true
            }
            this.pageloading=  false
        })

    }

    clickEditSubmitButton() {
        let flag = true
        if (!this.formData.payMethod) {
            this.$message.error('请选择付款方式');
            return;
        }
        /*必填项校验*/
        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return
            }
        })
        const obj = {
            id: this.backMoneyId,
            account: this.formData.backMoneyAccount,
            backMoneyAt: formatDate('yyyy-MM-dd', new Date(this.formData.date)),
            financeBackMoneyDetailList: [],
            financeBackMoneyProofList: this.fileList,
            directorUserId: this.formData.directorUserId,
            remark: this.formData.remark,
            payMethod: this.formData.payMethod,
            content:this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney))) ?this.needBackMoneyReason:''
        }


        obj.financeBackMoneyDetailList = this.tableData.map(item => {
            return ({
                financeOrderId: item.id,
                thisTimePrice: String(item.thisBackMoney),
                types: String(item.thisBackMoneyWay)
            })
        });

        const isAllZero = obj.financeBackMoneyDetailList.every(item => (item.thisTimePrice !== 0 && item.thisTimePrice !== ''));
        if (!isAllZero) {
            this.$message.error('有未填写本次回款金额的订单，请去填写')
            return;
        }
        /*判断this.tableData的每一项的thisBackMoneyWay都不为空*/
        if (!(obj.financeBackMoneyDetailList.every(item => (item.types !== '' && item.types !== 'undefined')))) {
            this.$message.error('有未填写本次回款方式的订单，请去填写')
            return
        }

        if (!this.needBackMoneyReason) {
            /*判断每一个订单的本次回款金额是否等于待回款金额*/
            if (this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney)))) {
                this.reasonDialogVisible = true
                flag = false
            }
        }
        if(flag){
            this.disabledButton = true
        }else{
            return;
        }
        this.pageloading = true
        setFinanceBackMoneyById(delNullProperty(obj)).then(res => {
            this.$message.success('保存成功，页面即将关闭')
            this.pageloading = false
            setTimeout(() => {
                this.closePage()
            }, 1500)
        }).catch(err => {
            if(err.message === '审批流报错') {
                this.errorDialogShow = true
            }
            this.disabledButton = false
            this.pageloading=  false
        })
    }
    getRowKeys (row) {
        return `${row.customerId}${row.customerType}`
    }
    choiceStudent(e) {
        this.studentDialogPage = 1
        this.studentDialogInputValue = ''
        this.studentDialog = true
        this.getCustomerNameListByFinanceBackMoneyMainPart()
        e.target.blur()
    }

    studentDialogConfirm() {
        this.studentConfirmList = this.studentDialogSelect  //存数据取消选中状态
        this.formData.studentName = this.studentDialogSelect.customerName
        this.studentDialog = false
        this.studentDialogInputValue = ''
        this.tableData = []
    }
    // 学生列表取消
    handleStudentDialog(){
        const id = this.studentConfirmList.customerId != this.studentDialogSelect.customerId
        const type = this.studentConfirmList.customerType != this.studentDialogSelect.customerType
        if(!this.studentConfirmList || ( id&&type )){
            const studentTable = this.$refs.studentDialogTable as HTMLFormElement
            studentTable.clearSelection()
            studentTable.toggleRowSelection(this.studentConfirmList,true)
        }
        if(this.studentConfirmList){
            const studentTable = this.$refs.studentDialogTable as HTMLFormElement
            studentTable.toggleRowSelection(this.studentConfirmList,true)
        }
        this.studentDialog = false
    }

    studentDialogSelectionChange(selectionArr: any[]) {
        if(selectionArr.length > 0) {
            this.studentDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            if(selectionArr.length > 1) {
                const studentTable = this.$refs.studentDialogTable as HTMLFormElement
                studentTable.clearSelection()
                studentTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for(const key in this.studentDialogSelect) {
                this.studentDialogSelect[key] = null
            }
        }
    }

    studentDialogPageChange(page: number) {
        this.studentDialogPage = page
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }

    // 新增一键设置价格
    clickSetPrice(){
        if(this.tableData.length == 0){
            this.$message.error('请添加订单')
            return
        }
        this.setPrice = ''
        this.setPriceDialogShow = true
    }
    handleSetPriceDialogSave(){
        if(this.setPrice == '' || this.setPrice == undefined || this.setPrice == null){
            this.$message.error('请填写本次回款金额')
            return
        }
        this.tableData = this.tableData.map(item => ({ ...item,thisBackMoney: this.setPrice, newNeedBackMoney:math.number( math.subtract(math.bignumber(Number(item.needBackMoney)) ,math.bignumber( Number(this.setPrice))))  }))
        this.setPriceDialogShow = false
    }

    // 一键设置回款方式
    clickSetBackMoneyWay(){
        if(this.tableData.length == 0){
            this.$message.error('请添加订单')
            return
        }
        this.setBackMoneyWay = ''
        this.setBackMoneyWayDialogShow = true
    }

    handleSetBackMoneyWayDialogSave() {
        if (this.setBackMoneyWay == '' || this.setBackMoneyWay == undefined || this.setBackMoneyWay == null) {
            this.$message.error('请填写本次回款方式')
            return
        }
        this.tableData = this.tableData.map(item => ({
            ...item,
            thisBackMoneyWay: this.setBackMoneyWay,
            thisBackMoney: this.setBackMoneyWay === '0'? item.price : item.thisBackMoney , // 一件设置回款 如果回款方式为全额 则本次回款金额为订单金额，否则为默认的
            newNeedBackMoney: math.number(math.subtract(math.bignumber(Number(item.needBackMoney)),math.bignumber(Number( this.setBackMoneyWay === '0'? item.price : item.thisBackMoney))))
        }))
        this.setBackMoneyWayDialogShow = false
    }


    clickAddOrder() {
        if(!this.formData.studentName) {
            this.$message.error('请选择学生')
            return
        }
        this.orderDialogPage = 1
        this.orderDialogInputValue = ''
        this.orderDialog =  true
        this.getFinanceOrderByCustomerIdOrMarketCooperationId()
        this.defaultChecked()
    }
    // 订单列表取消
    handleOrderDialog(){
        this.orderDialogSelectTable.map(item => {
            this.tableData.map(items => {
                if(item.id !== items.id){
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if(this.tableData.length > 0){
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableData.forEach(row => {
                orderDialogTable.toggleRowSelection(row,true)
            });
        }else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialog = false
    }
    // 添加订单--点击确认
    orderDialogConfirm() {
        this.tableData = []
        this.orderDialogSelectTable.map(item => {
            const Index = this.tableData.findIndex((items) => {return items.id === item.id})
            if(Index == -1){
                this.tableData.push({
                    ...item,
                    // thisBackMoney: 0,
                    thisBackMoney: item.thisBackMoney ? item.thisBackMoney : 0,
                    // newNeedBackMoney: item.needBackMoney,  //新建时候待回款金额
                    newNeedBackMoney: !item.thisBackMoney ? item.needBackMoney :(item.thisBackMoney==0?item.needBackMoney: math.number( math.subtract(math.bignumber(Number(item.needBackMoney)) ,math.bignumber(   Number(item.thisBackMoney)) ))),
                    oldThisBackMoney: 0, // 新建的时候默认 oldThisBackMoney = 0，当编辑审批通过的回款的时候，需要用来记录编前的当前回款
                    thisBackMoneyWay: item.thisBackMoneyWay ? item.thisBackMoneyWay : '',
                })
            }
        })
        this.formData.backMoneyAccount = this.tableData[0].companyName
        this.orderDialog = false
        this.orderDialogInputValue = ''
    }
    getRowKey(row){
        return row.id
    }

    orderDialogSelectionChange(selectionArr: any[]) {
        if (selectionArr.length > 0) {
            const val = selectionArr[0].companyName
            const flag = selectionArr.every(ele => ele.companyName === val)
            if (!flag) {
                this.$message.error('所选订单的收款账户不一致')
            }
        }
        this.orderDialogSelectTable = selectionArr
        if(this.tableData.length > 0){
            this.tableData.map(item => {
                this.orderDialogSelectTable.map(items => {
                    if(item.id == items.id) {
                        items.thisBackMoney = item.thisBackMoney
                        items.thisBackMoneyWay = item.thisBackMoneyWay
                    }
                })
            })
        }
    }

    orderDialogPageChange(page: number) {
        this.orderDialogPage = page
        this.getFinanceOrderByCustomerIdOrMarketCooperationId()
    }
    handleSizeChange(limit: number){
        this.limit = limit
        this.getFinanceOrderByCustomerIdOrMarketCooperationId()
    }
    handleBackMoneyOnInput(num,limit){
        const len1 = num.charAt(0)
        // 转化为数字形式--包含小数，负数
        // 先把非数字的都替换掉，除了数字和.
        num = num.replace(/[^\d.]/g, '')
        // 必须保证第一个为数字而不是.
        num = num.replace(/^\./g, '')
        // 保证只有出现一个.而没有多个.
        num = num.replace(/\.{2,}/g, '.')
        // 保证.只出现一次，而不能出现两次以上
        num = num.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        // 如果第一位是负号，则允许添加
        if (len1 === '-') {
            num = '-' + num
        }
        return num
    }
    thisBackMoneyChange(row, val){
        val = this.handleBackMoneyOnInput(val,'2')
        row.thisBackMoney = this.handleBackMoneyOnInput(val,'2')
        // if(Number(row.thisBackMoney) > Number(row.needBackMoney) + Number(row.oldThisBackMoney)) {
        //     this.$message.error('本次回款金额填写不正确')
        //     return
        // }
        // this.tableData = this.tableData.map(item => Object.assign(item, { newNeedBackMoney: Number(item.needBackMoney) - Number(val) }))
        this.tableData.forEach(item => {
            if(item.id === row.id) {
                item.newNeedBackMoney = math.number(math.subtract(math.bignumber(Number(item.needBackMoney)),math.bignumber(Number(val))))
            }
        })
    }

    clickDelOrder(row) {
        const order = this.$refs.orderDialogTable as HTMLFormElement
        this.tableData = this.tableData.filter(item => item.id !== row.id)
        this.orderDialogSelectTable = this.orderDialogSelectTable.filter(item => item.id !== row.id);
        this.tableData.forEach(row => {
            order.toggleRowSelection(row, true)
        })
    }

    clickSavaDraftButton() {
        this.isDraft = '1'
        this.saveDraftDialogShow = true
    }
    saveDraftDialogConfirm() {
        this.clickSubmintButton()
    }
    saveDraftDialogCancel() {
        this.isDraft = '0'
        this.saveDraftDialogShow = false
    }

    async clickStudentDialogFilter() {
        if (this.timernew !== null) clearTimeout(this.timernew)
        this.timernew = setTimeout(() => {
            this.studentDialogPage = 1
            this.getCustomerNameListByFinanceBackMoneyMainPart()
            // // 但搜索的内容为空的时候，调用获取方法
            // if(!this.studentDialogInputValue) {
            //     this.studentDialogTotal = 0
            //     this.getCustomerNameListByFinanceBackMoneyMainPart()
            //     return
            // }
            // this.studentDialogTableLoading = true
            // const data: any = await getCustomerNameListByFinanceBackMoneyMainPart({ mainPart: '0', page: this.studentDialogPage, limit: this.studentDialogTotal })
            // this.studentDialogTaleData = data.customerList.filter(item => item.customerName.includes(this.studentDialogInputValue))
            // this.studentDialogFilterTotal = this.studentDialogTaleData.length
            // this.studentDialogTotal = data.allNum
            // this.studentDialogTableLoading = false
        }, 1000)
    }


    clickOrderDialogFilter(val) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.orderDialogInputValue = val
            this.getFinanceOrderByCustomerIdOrMarketCooperationId()
        }, 1000)
    }

    setDraftById(isSubmit: string) {
        let flag = true;

        /*必填项校验*/
        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return
            }
        })
        if (!this.formData.payMethod) {
            this.$message.error('请选择付款方式');
            return;
        }
        const obj = {
            mainPart: '0',
            customerId: this.studentDialogSelect.customerId,
            customerType: this.studentDialogSelect.customerType,
            account: this.formData.backMoneyAccount,
            backMoneyAt: formatDate('yyyy-MM-dd', new Date(this.formData.date)),
            financeBackMoneyDetailList: [],
            financeBackMoneyProofList: this.fileList,
            directorUserId: this.formData.directorUserId,
            remark: this.formData.remark,
            payMethod: this.formData.payMethod,
            content: (this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney))) && isSubmit == '1') ? this.needBackMoneyReason : ''
        }
        obj.financeBackMoneyDetailList = this.tableData.map(item => {
            return ({
                financeOrderId: item.id,
                thisTimePrice: String(item.thisBackMoney),
                types: String(item.thisBackMoneyWay)
            })
        });

        const isAllZero = obj.financeBackMoneyDetailList.every(item => (item.thisTimePrice !== 0 && item.thisTimePrice !== ''));
        if (!isAllZero) {
            this.$message.error('有未填写本次回款金额的订单，请去填写')
            return;
        }
        /*判断this.tableData的每一项的thisBackMoneyWay都不为空*/
        if (!(obj.financeBackMoneyDetailList.every(item => (item.types !== '' && item.types !== 'undefined')))) {
            this.$message.error('有未填写本次回款方式的订单，请去填写')
            return
        }
        if (!this.needBackMoneyReason && isSubmit == '1') {
            /*判断每一个订单的本次回款金额是否等于待回款金额*/
            if (this.tableData.some(item => Number(item.thisBackMoney) < (Number(item.needBackMoney)))) {
                this.reasonDialogVisible = true
                flag = false
            }
        }
        if (flag) {
            this.disabledButton = true
        } else {
            return;
        }

        this.pageloading = true
        setDraftById({
            id: this.draftId,
            form: obj,
            isSubmit
        }).then(res => {
            this.$message.success(`${isSubmit === '0' ? '保存成功，页面即将关闭' : '提交成功，页面即将关闭'}`)
            this.pageloading = false
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            if (err.message == '审批流报错') {
                this.errorDialogShow = true
            }
            this.disabledButton = false
            this.pageloading=  false
        })
    }

    handleNeedBackMoneyReasonSave() {
        if (this.needBackMoneyReason) {
            if (!this.backMoneyId  && !this.draftId || this.orderId) {
                this.clickSubmintButton()
            } else if (this.backMoneyId ) {
                this.clickEditSubmitButton()
            } else if (this.draftId) {
                this.setDraftById('1')
            }
            this.reasonDialogVisible = false
        }
    }

    // 点击表格行选中该行  2021.9.27
    clickStudentDialogTableRow(row) {
        (this.$refs.studentDialogTable as HTMLFormElement).toggleRowSelection(row)
    }

    clickOrderDialotTableRow(row) {
        // if(row.needBackMoney == 0){ //禁用
        //     row.selectDisabled = false
        // }else if(row.needBackMoney != 0){
        //     row.selectDisabled = true
        // }
        // if(!(row.selectDisabled && row.needBackMoney !== 0)) return
        /*
    * 移除待回款金额为零时不可选的限制*/
        (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
    }

    orderDialogTableSelect(row) {
        // return row.needBackMoney !== 0 // 2023-6-27  去掉待回款金额为零不可选择的限制
    }


    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }
    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }
    closePage() {
        window.close()
    }

    changeDirectorUserId(e){
        this.formData.directorUserId = e.id
        if (e.id) {
            this.formData.deparment = e.departmentName
        }
    }

    @Watch('directorUserId',{ deep: true })
    handle(userId: string) {
        if(!this.formData.directorUserId){
            this.formData.directorUserId = userId
        }
    }

    @Watch('userName')
    handleChangeUserName(userName: string) {
        if (!this.formData.directorUserName) {
            this.formData.directorUserName = userName
        }
    }

    @Watch('department')
    handleChangeDepartment(department: string) {
        if (!this.formData.deparment) {
            this.formData.deparment = department
        }
    }
}
